import { Button, Copy, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useForm } from 'react-hook-form';
import { CookbookTextareaWrapper } from 'src/components/CookbookTextareaWrapper/CookbookTextareaWrapper';
import { parseChildAccountNames } from './parseChildAccountNames';

interface FormFields {
  names: string;
}

interface ChildAccountNameTextareaProps {
  onAdd: (names: string[]) => void;
  parentAccountName: string;
}

export default function ChildAccountNameTextarea({
  onAdd,
  parentAccountName,
}: ChildAccountNameTextareaProps): JSX.Element {
  const { control, formState, handleSubmit, reset } = useForm<FormFields>({
    mode: 'onChange',
  });
  function addChildAccountNames(formFields: FormFields) {
    const formattedNames = parseChildAccountNames(formFields.names);
    onAdd(formattedNames);
    reset({ names: '' });
  }

  const { isValid } = formState;

  const maxTextAreaLength = 7650; // 150 max accounts * 50 max characters + 150 whitespace

  return (
    <Stack>
      <Stack y="x-sm">
        <CookbookTextareaWrapper
          maxLength={maxTextAreaLength}
          name="names"
          label={`Child accounts for ${parentAccountName}`}
          control={control}
          blockWidth
          minHeight={218}
          id="childaccountsnameinput"
          inputSize="medium"
          rules={{
            validate: (value: string) => {
              return parseChildAccountNames(value).length !== 0;
            },
          }}
        />
      </Stack>
      <Stack y="x-sm">
        <Copy variant="caption" color="secondaryText">
          Add each name on a separate line and press "Add" so they appear below
          in your "Added child accounts".
        </Copy>
      </Stack>
      <Button
        disabled={!isValid}
        variant="secondary"
        buttonSize="medium"
        onClick={handleSubmit(addChildAccountNames)}
      >
        Add
      </Button>
    </Stack>
  );
}
